'use strict';

// This class attempts to centralize some functionality for the insights widgets.
// Add to it as you're able!
angular.module('MW.InsDashboard.ChartDataService', [
    'MW.Framework.TranslationService',
    'MW.InsDashboard.insightsBackendService',
    'DashboardChartConfigService',
    'MW.Framework.CoreCommon',
    'MW.Framework.DialogService',
    'CoreColorService',
    'MW.Dashboard.DashboardStateService',
    'MW.Dashboard.Base64Service',
    'MW.Framework.CoreUserService'
])
.factory('ChartDataService', [
    'translationService',
    'insightsBackendService',
    'DashboardChartConfigService',
    'CoreCommon',
    'DialogService',
    '$q',
    'CoreColorService',
    '$log',
    '$timeout',
    '$filter',
    '$rootScope',
    'DashboardStateService',
    'Base64Service',
    'CoreUserService', 
    function (
        translationService,
        insightsBackendService,
        DashboardChartConfigService,
        CoreCommon,
        DialogService,
        $q,
        CoreColorService,
        $log,
        $timeout,
        $filter,
        $rootScope,
        DashboardStateService,
        Base64Service,
        CoreUserService) {

    var serviceObj = {};

    serviceObj.activeTimeouts = {};
    serviceObj.cancelledTimeoutIds = [];

    var fetchAllData = function fetchAllData(chart, widgetScopeId){
        var params = angular.copy(chart.queryParameters),
            deferred = $q.defer(),
            incompleteQuery = false;
        params.insObject = chart.insObject;
        params.fetchDataForPreviousRange = chart.fetchDataForPreviousRange;
        params.previousDateStart = chart.previousDateStart;
        params.previousDateEnd = chart.previousDateEnd;
        params.agents = [];
        params.tags = [];
        params.rssFeeds = [];
        params.timezoneOverride = chart.timezoneOverride;

        var seriesList = {};

        //Ensure that the inputs are in a legacy format
        if(typeof chart.inputs !== 'undefined' && chart.inputs.length > 0){
            for(var i = 0; i < chart.inputs.length; i++){
                switch(chart.inputs[i].inputType){
                    case 'tags':
                        chart.inputs[i].id = chart.inputs[i].name;
                        params.tags.push(chart.inputs[i].name);
                        seriesList[chart.inputs[i].name] = chart.inputs[i];
                        break;
                    case 'rss':
                        seriesList[chart.inputs[i].id] = chart.inputs[i];
                        params.rssFeeds.push(chart.inputs[i].id);
                        break;
                    default:
                        seriesList[chart.inputs[i].id] = chart.inputs[i];
                        params.agents.push(chart.inputs[i].id);
                        break;
                }
            }

        }else{
            for (var i=0; i < chart.searches.length; i++){
                params.agents.push(chart.searches[i].agent);
                chart.searches[i].id = chart.searches[i].agent;
                chart.searches[i].inputType = "search";
                //build list of searches now, so we can reference it once response comes back
                seriesList[chart.searches[i].agent] = chart.searches[i];
            }
        }

        var allData = [];
        insightsBackendService.consolidatedService.query(params, function afterInsightsRequest(data){
            //format the data for transform functions
            angular.forEach(data.data, function(searchData, searchId){
                angular.forEach(searchData, function(singleSearch, searchId){
                    //add in our search information
                    singleSearch.search = seriesList[searchId];
                    if(singleSearch.complete !== 'undefined' && singleSearch.complete === false){
                        incompleteQuery = true;
                    }
                    allData.push(singleSearch);
                });
            });

            if (allData.length == 0) {
                chart.noDataError();
                deferred.resolve(true);
            }
            if (typeof chart.chartTransformFunction !== 'undefined') {

                //Fire off incremental loading if data is incomplete
                if(incompleteQuery === true && serviceObj.cancelledTimeoutIds.indexOf(widgetScopeId) < 0){
                    chart.pendingData = true;
                    serviceObj.activeTimeouts[widgetScopeId] = null;
                    var incrementalPromise = $timeout(function(){
                        serviceObj.fetchAllData(chart, widgetScopeId);
                    },4000);
                    serviceObj.activeTimeouts[widgetScopeId] = incrementalPromise;
                }else{
                    chart.pendingData = false;
                }

                chart.chartTransformFunction(allData, chart);
                deferred.resolve(true);
            } else {
                $log.error(chart);
                deferred.resolve(true);
            }
        }, function(err) {
            chart.loadingError();
            deferred.reject(err);
        });

        return deferred.promise;
    };

    serviceObj.fetchAllData = fetchAllData;

    $rootScope.$on("$routeChangeStart", function() {
        //Cancel anything that's already going
        for (var widgetId in serviceObj.activeTimeouts) {
            $timeout.cancel(serviceObj.activeTimeouts[widgetId]);
            delete serviceObj.activeTimeouts[widgetId];
            serviceObj.cancelledTimeoutIds.push(widgetId);
        }
    });

    var setDateAxis = function(dataSet, chart){
        var dateCategories = [];
        angular.forEach(dataSet, function(dataPoint){
            var label = DashboardChartConfigService.formatTimeInterval(dataPoint.date, chart.granularity, chart.fromDate, chart.toDate, chart.timezoneOverride);
            dateCategories.push(label);
        });
        return dateCategories;
    };
    serviceObj.setDateAxis = setDateAxis;

    var setDateSeriesWithLabel= function(dataSeries, transformPointFn, chart){
        var allSeries = [],
            deferred = $q.defer(),
            colorSet = CoreColorService.getColors('default');
        //each datapoint is an entry in the series
        // we need colors, click actions, tooltips etc
        CoreUserService.getCurrent(true).then((currentUser) => {
            var userLanguage = currentUser.language || 'en',
                userTimezone = currentUser.timezone;
        
            angular.forEach(dataSeries, function(series){
                var encodedInputId = Base64Service.encode(series.search.id);

                var thisColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId];
                
                if(series.isPreviousRange){
                        var color_index = DashboardStateService.inputIdsToColorMapping.colorIndex + 1
                        var thisColor  = colorSet[color_index]
                }
                if(DashboardStateService.inputIdsToColorMapping.colorIndex === colorSet.length) {
                    DashboardStateService.inputIdsToColorMapping.colorIndex = 0;
                }
                if (typeof thisColor === 'undefined') {
                    thisColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId] = colorSet[DashboardStateService.inputIdsToColorMapping.colorIndex++];
                }

                var mainSeries = {
                    name:series.search.name,
                    id:series.search.id,
                    showInLegend:false,
                    dataLabels: {
                        enabled: chart.dataLabels,
                        style: {
                            color: '#000'
                        }
                    },
                    color:thisColor,
                    linkedTo: series.search.name.toString() + '_' + series.search.id.toString(),
                    data:[]
                };
                for(var i=0; i < series.datapoints.length; i++){
                    mainSeries.data.push(transformPointFn(series.datapoints[i], dataSeries, i , chart));
                };
                var fakeSeries = {
                    name: series.search.name,
                    id:series.search.name.toString() + '_' + series.search.id.toString(),
                    showInLegend:true,
                    marker:{
                        symbol:'circle'
                    },
                    color:thisColor,
                    type:'scatter',
                    data:[]
                };

                /*
                * Compare ranges settings
                */
                if (dataSeries.length > 1) {
                    mainSeries.name = fakeSeries.name = series.search.name  + ' (' +  $filter('mwTranslateDate')(series.dateStart, 'mediumDate', userLanguage, userTimezone) + ' - ' + $filter('mwTranslateDate')(series.dateEnd, 'mediumDate', userLanguage, userTimezone)  + ')';
                    fakeSeries.id = series.search.name.toString() + '_' + series.search.id.toString();
                    if(series.isPreviousRange){
                        mainSeries.id = series.search.id;
                        mainSeries.linkedTo = series.search.name.toString() + '_' + series.search.id.toString() + '_previous';
                        fakeSeries.id = series.search.name.toString() + '_' + series.search.id.toString() + '_previous';
                    }
                }

                allSeries.push(mainSeries);
                allSeries.push(fakeSeries);
            });
            deferred.resolve(allSeries);

        });
        return deferred.promise;
    };
    serviceObj.setDateSeriesWithLabel = setDateSeriesWithLabel;

    var calculatePercentage = function(numerator, denominator){
        if(denominator === 0){
            return 100;
        } else if (numerator === 0){
            return 0;
        } else {
            return Math.round((parseInt(numerator) / parseInt(denominator) * 100)*100)/100;
        }
    };
    serviceObj.calculatePercentage = calculatePercentage;

    return serviceObj;
}]).filter('mwTranslateDate', [
    'moment', 
    function(moment) {
        return function(date, format, userLanguage, userTimezone) {
            if( date ) {
                var utcDate = moment.utc(date);

                    if( format ) {
                        switch(format) {
                            case 'mediumDate': {
                                return utcDate.tz(userTimezone).locale(userLanguage).format('MMM Do, YYYY');
                            }
                            case 'fullDate': {
                                return utcDate.tz(userTimezone).locale(userLanguage).format('dddd, MMM Do, YYYY');
                            }
                            default: {
                                return utcDate.tz(userTimezone).locale(userLanguage).format(format);
                            }
                        }
                    }
                    else {
                        return utcDate.tz(userTimezone).locale(userLanguage).format();
                    }

            }
            else {
                return '';
            }
        };
}]);